module.exports = __webpack_public_path__ + "static/media/magazineTupp_03_full.2b206831.jpg";